import React from 'react';
import { Button, ButtonGroup } from 'components/ui';

const TemplateCardBack = React.forwardRef(
  (
    { template, previewUrl, setIsFocused, formattedDate, selectTemplate },
    ref,
  ) => {
    return (
      <div
        className="TemplateCard-back d-f fd-c jc-sb bg-white"
        ref={ref}
        onClick={e => e.stopPropagation()}
        onKeyDown={() => {}}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      >
        <div className="TemplateCard-description">
          {template.description ||
            t('templates.gallery.last_updated_on', { date: formattedDate })}
        </div>
        <ButtonGroup className="TemplateCard-buttonGroup">
          <Button url={previewUrl} target={`template_preview_${template.id}`}>
            {t('templates.gallery.preview')}
          </Button>
          <Button
            onClick={() => selectTemplate(template.id)}
            customColor
            className="TemplateCard-submitButton"
          >
            {t('templates.gallery.use')}
          </Button>
        </ButtonGroup>
      </div>
    );
  },
);

export default TemplateCardBack;
